export const recaptcha_public_key = '6Lfz6ucZAAAAAI_WCvOeuRJyUbNZAOlhBRdkBdE9';

export const siteUrl = 'https://books.spearmintlabs.org';